/**
 * Analytics service for company dashboard
 */

const API_BASE_URL = 'https://universal-ai-agent-backend.diypa571.workers.dev'

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
  message?: string
}

class AnalyticsService {
  private getToken(): string | null {
    return localStorage.getItem('token')
  }

  private getHeaders(): HeadersInit {
    const token = this.getToken()
    return {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    }
  }

  /**
   * Get analytics data for company
   */
  async getAnalytics(days: number = 30, agentId?: number): Promise<ApiResponse<any>> {
    try {
      let url = `${API_BASE_URL}/api/analytics?days=${days}`
      if (agentId) {
        url += `&agentId=${agentId}`
      }

      console.log('Fetching analytics from:', url)
      console.log('Auth token:', this.getToken() ? 'Present' : 'Missing')

      const response = await fetch(url, {
        method: 'GET',
        headers: this.getHeaders()
      })

      console.log('Analytics response status:', response.status)

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Failed to fetch analytics' }))
        console.error('Analytics API error:', error)
        return { success: false, error: error.message }
      }

      const data = await response.json()
      console.log('Analytics API response:', data)
      return { success: true, data: data.data }
    } catch (error) {
      console.error('Get analytics error:', error)
      return { success: false, error: 'Failed to fetch analytics' }
    }
  }

  /**
   * Get top topics from conversations
   */
  async getTopics(limit: number = 20): Promise<ApiResponse<any>> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/analytics/topics?limit=${limit}`, {
        method: 'GET',
        headers: this.getHeaders()
      })

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Failed to fetch topics' }))
        return { success: false, error: error.message }
      }

      const data = await response.json()
      return { success: true, data: data.data }
    } catch (error) {
      console.error('Get topics error:', error)
      return { success: false, error: 'Failed to fetch topics' }
    }
  }
}

export const analyticsService = new AnalyticsService()

